"use client";

import {useHydrationSafeFeatureFlagEnabled} from "@/hooks/useHydrationSafeFeatureFlagEnabled";

export const PHONE_SURVEYS_FEATURE_FLAG = "ui-enable-phone-surveys";

/**
 * Mount-gated so the phone-surveys Switch is absent on SSR and first paint,
 * then appears after mount when the flag is on (avoids React #418).
 */
export function usePhoneSurveysFeatureEnabled(): boolean {
   return useHydrationSafeFeatureFlagEnabled(PHONE_SURVEYS_FEATURE_FLAG);
}
